/* LM plus PDP (preview 21 okt 2026): 3) afwijkend pasvormadvies als opvallend vak. Kleurfoto's (punt 4) staan server-side in snippets/lm-color-photos.liquid. Stijl in lm-plus.css. */
(function () {
  if (window.__lmPlusPdp) return;
  window.__lmPlusPdp = true;
  var WARN = /(valt (ruim|klein|groot|kort|lang)|kies (dan )?de (kleinste|grootste)|maat (groter|kleiner)|kleiner|groter)/i;
  function pdpFit() {
    var el = document.querySelector('[data-lm-fit] .lm-fit__text');
    if (el && !el.classList.contains('lm-fit__text--warn') && WARN.test(el.textContent)) el.classList.add('lm-fit__text--warn');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pdpFit); else pdpFit();
})();